import styled from 'styled-components';
import ArrowBackIos from '@material-ui/icons/ArrowBackIos';
import LocalShipping from '@material-ui/icons/LocalShipping';
import LocationCity from '@material-ui/icons/LocationCity';
import FlightTakeoff from '@material-ui/icons/FlightTakeoff';
import DirectionsWalk from '@material-ui/icons/DirectionsWalk';
import { makeStyles } from '@material-ui/core';

import THEME from '../../../../../constants/theme';

export const AreaContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ServiceCode = styled.p`
  color: ${THEME.grey};
  flex: 1;
  justify-self: center;
  font-family: Montserrat;
  font-size: 16px;
  font-weight: 500;
  line-height: 1.5;
  letter-spacing: 0.2px;
  margin: 0;
`;

export const IconAirplane = styled(FlightTakeoff)`
  color: ${THEME.blue};
  margin-left: 3px;
`;

export const IconBack = styled(ArrowBackIos)`
  color: ${THEME.grey};
  margin-left: 10px;

  &:hover {
    cursor: pointer;
  }
`;

export const IconCity = styled(LocationCity)`
  color: ${THEME.orange};
  margin-left: 3px;
`;

export const IconTruck = styled(LocalShipping)`
  color: ${THEME.orange};
  margin-left: 3px;
`;

export const IconWalk = styled(DirectionsWalk)`
  color: ${THEME.green};
  margin-left: 3px;
`;

export const StatusText = styled.p`
  align-items: center;
  border: 1px solid ${props => props.color};
  border-radius: 12px;
  color: ${props => props.color};
  display: flex;
  font-family: Montserrat;
  font-size: 14px;
  font-weight: 500;
  justify-content: center;
  letter-spacing: 0.5px;
  margin: 0;
  min-width: 88px;
`;

export const Text = styled.p`
  color: ${THEME.bobBlack};
  font-family: Montserrat;
  font-size: 14px;
  font-weight: 500;
  margin: 0;
`;

// TODO: Replace colors with material-ui colors
export const useHeaderStyles = makeStyles(theme => ({
  root: {
    display                     : 'flex',
    borderBottom                : `1px solid ${THEME.lightGrey}`,
    minHeight                   : '67.5px',
    alignItems                  : 'center',
    flexWrap                    : 'wrap',
    gap                         : theme.spacing(0, 1),
    [theme.breakpoints.up('sm')]: {
      gap: theme.spacing(0, 4),
    },
  },

}));
